import { AutogenLayoutOfficeAdditionalTaxesReport } from "./autogen/AutogenLayoutOfficeAdditionalTaxesReport";

export class OfficeAdditionalTaxesReport extends AutogenLayoutOfficeAdditionalTaxesReport {

    onLoad(): void {
        super.onLoad();
        this.textboxReportBy.selectedItem = this.textboxReportBy.items[0];
        this.textboxTaxType.selectedItem = this.textboxTaxType.items[0];
        this.textboxSecondaryGroupBy.selectedItem = this.textboxSecondaryGroupBy.items[0];
    }

    textboxReportByOnChange() {
        const reportBy = this.textboxReportBy?.text;
        const common = {
            lookupModelAllowMultiSelect: true,
            lookupModelResultField: "id",
            lookupModelDisplayField: "descr"
        };
        if (this.excludabletextboxState.textbox) {
            this.excludabletextboxState.textbox.clear();
        }

        if (reportBy === "City") {
            this.excludabletextboxState.textbox.caption = "Cities";
            this.excludabletextboxState.textbox.lookupModel = "lme/settlement/city";
            this.excludabletextboxState.textbox.lookupModelLayout = "lme/settlement/CityLookup";
        } else if (reportBy === "County") {
            this.excludabletextboxState.textbox.caption = "Counties";
            this.excludabletextboxState.textbox.lookupModel = "lme/settlement/county";
            this.excludabletextboxState.textbox.lookupModelLayout = "lme/settlement/CountyLookup";
        }
        else {
            this.excludabletextboxState.textbox.caption = "States";
            this.excludabletextboxState.textbox.lookupModel = "lme/settlement/state";
            this.excludabletextboxState.textbox.lookupModelLayout = "lme/settlement/StateLookup";
        }
        this.excludabletextboxState.textbox.lookupModelAllowMultiSelect = common.lookupModelAllowMultiSelect;
        this.excludabletextboxState.textbox.lookupModelResultField = common.lookupModelResultField;
        this.excludabletextboxState.textbox.lookupModelDisplayField = common.lookupModelDisplayField;

}

checkboxIncludeSettlementOnChange() {
        this.excludabletextboxPayees.textbox.clear();
        if(this.checkboxIncludeSettlements.checked) {
            this.excludabletextboxPayees.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayees.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        }
        else {
            this.excludabletextboxPayees.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayees.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
    }
}
